import { Col, Container } from '@microfrontends/react-components'
import { Paragraph } from '../../../components/NumerologyV2/index.css'
import Title from '../../../components/NumerologyV2/Title'
import { ResponsibilityCss } from '../Numerology.css'

export default function Responsibility() {
	return (
		<Container>
			<ResponsibilityCss justify={'center'}>
				<Title
					title='Miễn trừ trách nhiệm thông tin Nhân số học'
					marker='star'
					backgound='oval'
				/>
				<Col>
					<Paragraph>
						Các thông tin và phân tích về Nhân số học do
						VietnamWorks tổng hợp nhằm giúp người xem tự đối chiếu
						lại với những gì đã cảm nhận, đánh giá về bản thân mình,
						từ đó tìm hiểu thêm các công việc phù hợp, lộ trình phát
						triển của công việc đó, và xây dựng sự nghiệp hạnh phúc
						hơn.
					</Paragraph>
					<Paragraph>
						Vì vậy, tra cứu nhân số học, thần số học online chỉ mang
						tính chất tham khảo, không được xem là công cụ tư vấn
						chuyên nghiệp. Bạn có thể sử dụng tài liệu này để đối
						chiếu, nếu bạn thấy thông tin đúng với những gì bạn đánh
						giá về bản thân và muốn tìm hiểu thêm về lộ trình phát
						triển sự nghiệp phù hợp với thế mạnh, bạn có thể xem
						thêm phần thông tin về Career path - Lộ trình phát triển
						sự nghiệp để từ đó định hướng sự nghiệp tốt hơn cho
						chặng đường phía trước.
					</Paragraph>
					<Paragraph style={{ marginBottom: 0 }}>
						Khi đồng ý xem bài phân tích này, bạn sẽ chịu trách
						nhiệm về việc sử dụng thông tin làm tài liệu tham khảo.
						VietnamWorks không chịu trách nhiệm cho bất kỳ khiếu
						nại, thiệt hại do sử dụng thông tin trên Website.
					</Paragraph>
				</Col>
			</ResponsibilityCss>
		</Container>
	)
}
